import React from "react";
import "./page.css";
import dashboard1 from '../logo/dashboard_home.png'
import dashboard2 from '../logo/dashboard_ssh.png'
import dashboard3 from '../logo/dashboard_network.png'
import dashboard4 from '../logo/dashboard_metric_1.png'
import dashboard5 from '../logo/dashboard_metric_2.png'

const Dashboard = () => {
    const title = (
        <>
            Dashboard
        </>  
    );

    const paraText = `In progress...`;

    return (
        <div className="page">
            <div className="page-title">
                <h1>{title}</h1>
            </div>
            <br />
            <br />
            <br />

            <div className="page-item">
                <p>{paraText}</p>
                Real-time dashboards will be soon available on this page.
                <br/>
                Preview below.
            </div>
            <br />
            <br />

            <div className="page-preview">
                <img src={dashboard1} alt={"dashboard1"} className="banner" />
                <img src={dashboard2} alt={"dashboard2"} className="banner" />
                <img src={dashboard3} alt={"dashboard3"} className="banner" />
                <img src={dashboard4} alt={"dashboard4"} className="banner" />
                <img src={dashboard5} alt={"dashboard5"} className="banner" />
            </div>

            {/* <iframe 
                src="http://localhost:3000/d-solo/rbaPinkiePoneyfsdqf5sss/pink-rba-rennes?orgId=1&from=1696975200000&to=1697061599000&panelId=43" 
                width="450" 
                height="500" 
                frameborder="0"
            ></iframe>

            <iframe 
                src= "http://localhost:3000/public-dashboards/05027ea24b3f431ab4a9e3f1d8c1e78c"  //"http://localhost:3000/public-dashboards/e32a1022e3244724a271d592894f4510" 
                width="1500" 
                height="900"
                frameborder="0"                 
            ></iframe> */}

            <br />
            <br />
        </div>
    );
};

export default Dashboard;
